import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Get Backend URL from environment variable (required for deployment)
const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

console.log('[App] Backend URL:', API_BASE_URL);

// Configure global fetch for native apps (Capacitor iOS/Android)
const originalFetch = window.fetch;
window.fetch = function(url, options = {}) {
  // If URL starts with /api, prepend the backend URL
  let finalUrl = url;
  if (typeof url === 'string' && url.startsWith('/api/')) {
    finalUrl = `${API_BASE_URL}${url}`;
    console.log('[GlobalFetch] Converted relative URL to:', finalUrl);
  }
  
  // Add default headers for all API requests
  const isApiRequest = typeof finalUrl === 'string' && finalUrl.includes('/api/');
  
  if (isApiRequest) {
    const enhancedOptions = {
      ...options,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        ...options.headers,
      },
    };
    console.log('[GlobalFetch] API Request:', finalUrl);
    return originalFetch(finalUrl, enhancedOptions);
  }
  
  return originalFetch(finalUrl, options);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ---- PWA: Register service worker (web only, not Capacitor native) ----
if (
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  !window.Capacitor?.isNativePlatform?.() &&
  window.location.protocol !== 'file:'
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((reg) => console.log('[PWA] SW registered:', reg.scope))
      .catch((err) => console.warn('[PWA] SW registration failed:', err));
  });
}

